export default "__VITE_ASSET__C3c0E50P__"